module.exports = __webpack_public_path__ + "img/1449191242.b5435917.jpg";